import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import userDefaultAvatar from '../../../../assets/img/placeholder-user.png';
import { onUserImgError } from '../../../../helpers/Helpers';
import { NavLink } from 'react-router-dom';
import { ReactComponent as StudentSvg } from '../../../../assets/svg/icons/Student.svg';
import { ReactComponent as AlumniSvg } from '../../../../assets/svg/icons/Alumni.svg';
import { ReactComponent as StaffSvg } from '../../../../assets/svg/icons/Staff.svg';
import { ReactComponent as SchoolStudentSvg } from '../../../../assets/svg/icons/school-student.svg';
import { ReactComponent as ParentSvg } from '../../../../assets/svg/icons/Parent.svg';
import { ReactComponent as ChildSvg } from '../../../../assets/svg/icons/Child.svg';
import dayjs from 'dayjs';
import { getSchoolCurriculum, prepareYearOfStudying } from '../../../../helpers/StudentHelper';
import { Button, Image } from 'antd';

class AmbassadorProfilePopup extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            rate: null,
            isBtnDisabled: true,
        };
    }

    showChildren = (children) => {
        return children.map((child, index) => (
            <div key={index} className="parent-child">
                <span className="member-info-child-icon">
                    <ChildSvg className="child-icon" />
                </span>
                <span className="member-info-child-age">{dayjs().diff(child.age, 'years')} years old</span>
                <span className="member-info-child-year-of-study">
                    ( {getSchoolCurriculum(child.studying_year)} {prepareYearOfStudying(child.studying_year)} )
                </span>
            </div>
        ));
    };

    render() {
        const { member, online, commonRoutePath, goToStudent, currentChat } = this.props;
        const country = member.user_tags && member.user_tags.countries ? member.user_tags.countries[0].name : null;
        const region = member.region ? member.region : '';
        let studentData = null;
        if (member.user_tags.student) {
            member.user_tags.student.map((tag) => {
                studentData = (studentData ? studentData + ', ' : '') + tag.name;
            });
        }

        return (
            <div className="chat-member-popup scroll-8">
                <div className="chat-name-head-row">
                    <div className={'chat-name-img-container ' + (online < 5 ? 'mod-online' : 'mod-offline')}>
                        <Button
                            className="chat-name-img-block ambassador-chat-image"
                            onClick={() => goToStudent(member)}
                        >
                            <Image
                                className="chat-name-img"
                                src={
                                    member.avatar
                                        ? member.avatar.sizes['70x70'] || member.avatar.original
                                        : userDefaultAvatar
                                }
                                onError={onUserImgError}
                                alt={member.name ? member.name.slice(0, 1).toUpperCase() : 'D'}
                            />
                        </Button>
                    </div>

                    <div className="chat-name-block">
                        <NavLink
                            end
                            to={
                                commonRoutePath +
                                '/chat-to-us/' +
                                (member.role_key === 'univercity-student' ? member.id : 'university')
                            }
                            className="chat-name ambassador-chat-name-header"
                        >
                            {member.name}
                        </NavLink>
                        {member.user_tags && member.user_tags.student && (
                            <div className="member-sa-info">
                                <span className="member-icon-block">
                                    <StudentSvg className="student-svg" />
                                    <span>Student</span>
                                </span>

                                {studentData && <div className="member-popup-student-data">({studentData})</div>}
                            </div>
                        )}
                        {member.user_tags &&
                            member.user_tags.profile &&
                            member.user_tags.profile[0] &&
                            member.user_tags.profile[0].key === '_school_student' && (
                                <div className="member-sa-info">
                                    <span className="member-icon-block">
                                        <SchoolStudentSvg className="student-scholar-svg" />
                                        <span>Student</span>
                                    </span>
                                </div>
                            )}
                        {member.user_tags &&
                            member.user_tags.content &&
                            member.user_tags.content[0] &&
                            member.user_tags.content[0].key === '_alumni' && (
                                <div className="member-sa-info">
                                    <span className="member-icon-block">
                                        <AlumniSvg className="alumni-svg" />
                                        <span>Alumni</span>
                                    </span>
                                </div>
                            )}
                        {member.user_tags && member.user_tags.staff && (
                            <div className="member-sa-info">
                                <span className="member-icon-block">
                                    <StaffSvg className="staff-svg" />
                                    <span>Staff</span>
                                </span>
                            </div>
                        )}
                        {member.user_tags &&
                            member.user_tags.profile &&
                            member.user_tags.profile[0] &&
                            member.user_tags.profile[0].key === '_parent' && (
                                <div className="member-sa-info">
                                    <span className="member-icon-block">
                                        <ParentSvg className="parent-svg" />
                                        <span>Parent</span>
                                    </span>
                                </div>
                            )}
                        <p className="chat-member-skills">
                            {member.user_tags.courses_types ? member.user_tags.courses_types[0].name + ' ' : ''}
                            {member.user_tags.subject ? member.user_tags.subject[0].name + ' ' : ''}
                            {member.user_tags.job_role ? member.user_tags.job_role[0].name + ' ' : ''}
                            {member.user_tags.industry ? member.user_tags.industry[0].name : ''}
                            {member.user_tags.staff ? member.user_tags.staff[0].name + ' Staff' : ''}
                        </p>
                        {member.children && member.children[0] && (
                            <>
                                <p className="member-text-bold">
                                    Children at{' '}
                                    {currentChat.data && currentChat.data.university
                                        ? currentChat.data.university.name
                                        : ''}
                                    :
                                </p>
                                {this.showChildren(member.children)}
                            </>
                        )}

                        {country && (
                            <div className="member-text-from">
                                <p className="member-text-bold">From:</p>
                                <p className="member-from-text">{(region ? region + ',  ' : '') + country}</p>
                            </div>
                        )}
                        {member.user_tags.interests && (
                            <div className="member-interests-block">
                                <p className="member-text-bold">Interests and clubs/societies:</p>
                                <div className="student-tags-row">
                                    {member.user_tags.interests.map((interest, index) => {
                                        return (
                                            <span key={index} className="student-tag">
                                                {interest.name}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state) => {
    return {
        account: state.account,
        currentChat: state.currentChat,
    };
})(AmbassadorProfilePopup);
